var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-header d-flex align-center mx-2"},[_c('div',[_vm._v(_vm._s(_vm.construction_site.name))]),_c('div',{staticClass:"ml-auto"},[_c('v-btn',{on:{"click":function($event){return _vm.$router.push({
            name: 'ConstructionSiteEdit',
            params: { id: _vm.$route.params.id },
          })}}},[_c('v-icon',[_vm._v(" mdi-cog ")])],1)],1)]),_c('l-map',{staticStyle:{"width":"100%","height":"calc(100vh - 112px)","z-index":"99"},attrs:{"crs":_vm.crs,"center":_vm.center,"bounds":_vm.bounds,"options":{
      contextmenu: true,
      contextmenuItems: [
        {
          text: 'この地点にマーカーを作成する',
          index: 0,
          callback: _vm.openDialog,
        } ],
    }}},[_c('l-image-overlay',{attrs:{"url":_vm.mapURL,"bounds":_vm.bounds}}),_vm._l((_vm.markers),function(m){return _c('l-marker',{key:m.id,attrs:{"lat-lng":[m.lat, m.lng],"options":{
        marker_id: m.id,
        contextmenu: true,
        contextmenuItems: [
          {
            text: 'このマーカーを削除する',
            index: 0,
            callback: _vm.deleteMarker,
          } ],
        contextmenuInheritItems: false,
      }},on:{"click":function($event){return _vm.$router.push({
          name: 'MeasureGraph',
          params: { id: m.measure_id },
        })}}},[_c('l-icon',{attrs:{"icon-anchor":[16, 37]}},[_c('div',{staticClass:"header"},[_c('span',[_vm._v(_vm._s(m.name))])]),_c('div',{staticClass:"markerIcon"},[_c('span',[_vm._v(_vm._s(m.value)+_vm._s(_vm.$sanitize(m.value_unit)))])])])],1)})],2),_c('v-dialog',{staticClass:"dialog",attrs:{"max-width":"600"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2"},[_vm._v(" マーカーの作成 ")]),_c('v-card-text',[_c('v-select',{attrs:{"label":"計測を選択","items":_vm.unusedMeasures,"item-text":"name","item-value":"id"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_c('v-divider'),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.clickCreate}},[_vm._v(" 作成 ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }